import { useEffect, useRef, useState } from "react";

// Counts down to `targetMs` (server time). `serverNow` is the server clock
// when the target was issued, so a wrong device clock does not move the end.
export default function useCountdown(targetMs, serverNow, onDone) {
  const offset = useRef(serverNow ? serverNow - Date.now() : 0);
  const done = useRef(onDone);
  done.current = onDone;
  const remaining = () => (targetMs ? targetMs - (Date.now() + offset.current) : 0);
  const [left, setLeft] = useState(remaining);

  useEffect(() => {
    offset.current = serverNow ? serverNow - Date.now() : 0;
    setLeft(remaining());
    const tick = setInterval(() => {
      const next = remaining();
      setLeft(Math.max(0, next));
      if (next <= 0) {
        clearInterval(tick);
        done.current?.();
      }
    }, 1000);
    return () => clearInterval(tick);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetMs, serverNow]);

  return Math.max(0, left);
}
